import type { Node } from "./FlujoBaseSVG";

interface NodeProps {
	readonly node: Node;
	readonly onClick: (nodeId: string, event: React.MouseEvent) => void;
	readonly selected: boolean;
}
export function BaseNode({ node, onClick, selected }: NodeProps) {
	const style = {
		transform: `translate(${node.position.x}px, ${node.position.y}px)`,
		width: node.size.width,
		height: node.size.height,
		position: "absolute",
		display: "flex",
		alignItems: "center",
	} as const;

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClick(node.id, e);
	};

	return (
		<div style={style}>
			<div onClick={handleClick} className={`node ${selected ? "selected" : ""}`}>
				{node.node}
				{/* <div className="node-svg"></div> */}
				{node.label.split("\n").map((line) => (
					<div key={line} className="node-label">
						{line}
					</div>
				))}
			</div>
		</div>
	);
}
